import { CrossDockTracking, CrossDockTrackingResponse } from './crossDockTrackingTypes';

export const mockCrossDockTracking: CrossDockTracking = {
  orderId: 1,
  firstMilePackages: [
    {
      parcelNumber: '123',
      parcelFullNumber: '123-FULL',
      parcelTrackingUrl: 'https://tracking.com/package/123',
      carrier: {
        identifier: 'DPD',
      },
    },
  ],
};

export const mockSaveCrossDockTrackingsResponse: CrossDockTrackingResponse = {
  trackings: [mockCrossDockTracking],
};
